module.exports = __webpack_public_path__ + "static/img/80-2.499206b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/80-2.jpg
// module id = b4Kp
// module chunks = 0